export default {
  search: "",
  show: false
};
